// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__x3ayb","question":"styles_question__2Mc4E","description":"styles_description__2lZ_0"};